module.exports = __webpack_public_path__ + "img/bkd_android_code.58be8c25.png";